<template>
  <div :class="[_.timer, rectangle && _.rectangle]">
    <div :class="_.item">{{ seckillInfo.diff.h }}</div>
    <div :class="_.divider" />
    <div :class="_.item">{{ seckillInfo.diff.i }}</div>
    <div :class="_.divider" />
    <div :class="_.item">{{ seckillInfo.diff.s }}</div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      // 是否使用长方形样式，用于商品详情页
      // 默认使用正方形样式，用于首页秒杀模块
      rectangle: {
        type: Boolean,
        default: false,
      },

      // 秒杀信息
      seckillInfo: {
        type: Object,
        required: true,
      },
    },
  })
</script>

<style lang="scss" module>
  .timer {
    display: flex;
    align-items: center;
    color: #eb1a1c;

    .item {
      width: 18px;
      height: 18px;
      background: #ffffff;
      border-radius: 2px;
      font-size: 14px;
      font-family: Bebas-Regular;
      color: currentColor;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 1;
    }

    .divider {
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      background-image: url('./images/正方形秒杀冒号.png');
      width: 4px;
      height: 12px;
      margin: 0 2px;
    }

    &.rectangle {
      .item {
        width: 20px;
        height: 24px;
        font-size: 18px;
      }

      .divider {
        background-image: url('./images/长方形秒杀冒号.png');
        width: 3px;
        height: 16px;
        margin: 0 6px;
      }
    }
  }
</style>
